<template>
  <div>
    <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Plano de Cuidados</h1>
    <data-table
      v-if="loadTable"
      v-model:columns="columns"
      :route="'/patients/care-plans/' + patient.id"
      no-data-label="Nenhum plano de cuidado cadastrado"
      no-result-label="Nenhum plano de cuidado encontrado"
    >
      <template #table.cell.content.actions="{ value, row }">
        <div class="inline-grid grid-cols-2 gap-4 ">
          <span v-if="user.role == 1 || row.professional_id == user.professional.id" @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
          <span v-if="user.role == 1 || row.professional_id == user.professional.id" @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
        </div>
      </template>
      <template #grid.content.body.actions="{ value, row }">
        <div class="inline-grid grid-cols-2 gap-4 ">
          <span v-if="user.role == 1 || row.professional_id == user.professional.id" @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
          <span v-if="user.role == 1 || row.professional_id == user.professional.id" @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
        </div>
      </template>

      <template #after.reload-button>
        <button v-if="user.role == 2" class="flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="openModalEdit({})">
          <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block"> Adicionar Plano de Cuidados</span>
        </button>
      </template>
    </data-table>
  </div>
  <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
  <modal-edit ref="modalEdit" title="Plano de Cuidados" :url="'patients/care-plans/' + patient.id" @submitForm="reloadTable">
    <template #form="{item}">
      <select-input v-model="item.type" :error="item.errors.type" class="lg:pr-6 lg:mt-0 w-full lg:w-1/2" label="Tipo do Problema">
        <option v-for="(value, name, index) in this.care_plan_types()" :key="name" :value="name">{{ value }}</option>
      </select-input>
      <select-input v-model="item.problem" :error="item.errors.problem" class="mt-6 lg:mt-0 w-full lg:w-1/2" label="Problema">
        <option v-for="(value, name, index) in problemList" :key="name" :value="name">{{ value }}</option>
      </select-input>
      <text-input v-model="item.goal" :error="item.errors.goal" class="mt-6 w-full" label="Meta vinculada" />
      <vue-select-input v-if="user.role == 1" :getOptionLabel="(professional) => professional.user?.name" v-model="item.professional" :options="this.professionals()" :error="item.errors[`professional.id`]" class="mt-6 lg:pr-6 w-full lg:w-1/2" label="Profissional" text="nenhum profissional encontrado" />
      <div class="w-full"></div>
      <button class="mt-6 flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="item.activities.push({frequency: null, alert_start: null, alert_repeat: null, alert_repeat_type: null, goal: {}});">
        <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /> Adicionar Atividade
      </button>
      <div class="w-full flex flex-wrap p-6 mt-4 bg-gray-100/50" v-for="(activity, activity_index) in item.activities">
        <vue-select-input v-model="activity.goal" :options="this.goals()" :error="item.errors[`activities.`+activity_index+`.goal.id`]" class="lg:pr-6 w-full lg:w-2/4" label="Ação" text="nenhuma ação encontrada" />
        <mask-input v-if="activity.goal?.type == 'meta'" mask="######" v-model="activity.value" :error="item.errors[`activities.`+activity_index+`.value`]" class="mt-6 lg:mt-0 w-full lg:w-2/4" label="Meta" />
        <mask-input v-if="activity.goal?.type == 'minimo_maximo'" mask="######" v-model="activity.min" :error="item.errors[`activities.`+activity_index+`.min`]" class="lg:pr-6 mt-6 lg:mt-0 w-full lg:w-1/4" label="Mínimo" />
        <mask-input v-if="activity.goal?.type == 'minimo_maximo'" mask="######" v-model="activity.max" :error="item.errors[`activities.`+activity_index+`.max`]" class="mt-6 lg:mt-0 w-full lg:w-1/4" label="Máximo" />
        <div v-if="activity.goal?.type != 'meta' && activity.goal?.type != 'minimo_maximo'" class="w-full lg:w-2/4"></div>
        <select-input v-model="activity.frequency" :error="item.errors[`activities.`+activity_index+`.frequency`]" class="mt-6 lg:pr-6 w-full lg:w-2/6" label="Frequência">
          <option v-for="(value, name, index) in this.care_plan_frequencies()" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <date-input v-model="activity.date_end" :error="item.errors[`activities.`+activity_index+`.date_end`]" class="mt-6 lg:pr-6 w-full lg:w-2/6" label="Validade" />
        <switch-input v-model="activity.alert" class="w-5/6 mt-6 lg:w-1/6" label="Alerta" labelChecked="Sim" labelUnchecked="Não" />
        <div class="mt-6 lg:mt-0 w-1/6 lg:w-1/6 self-center text-right">
          <span @click="deleteActivity(item, activity)"><font-awesome-icon icon="fa-xmark" class="text-gray-600 text-lg cursor-pointer" /></span>
        </div>
        <time-input v-if="activity.alert" v-model="activity.alert_start" :error="item.errors[`activities.`+activity_index+`.alert_start`]" class="lg:pr-6 mt-6 w-full lg:w-1/2" label="Hora Início do alerta" />
        <mask-input v-if="activity.alert && activity.frequency > 1" mask="###" v-model="activity.alert_repeat" :error="item.errors[`activities.`+activity_index+`.alert_repeat`]" class="lg:pr-6 mt-6 w-full lg:w-1/4" label="Repetir a cada" />
        <select-input v-if="activity.alert && activity.frequency > 1" v-model="activity.alert_repeat_type" :error="item.errors[`activities.`+activity_index+`.alert_repeat_type`]" class="mt-6 lg:mt-14 w-full lg:w-1/4">
          <option v-for="(value, name, index) in this.care_plan_alert_repeat_types()" :key="name" :value="name">{{ value }}</option>
        </select-input>
      </div>
    </template>
  </modal-edit>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import DataTable from '@/Shared/DataTable'
import SwitchInput from '@/Shared/SwitchInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import DateInput from '@/Shared/DateInput'
import VueSelectInput from '@/Shared/VueSelectInput'
import MaskInput from '@/Shared/MaskInput'
import TimeInput from '@/Shared/TimeInput'

export default {
  inject: ['patient', 'professionals', 'goals', 'care_plan_types', 'care_plan_problems', 'care_plan_frequencies', 'care_plan_alert_repeat_types'],
  components: {
    LoadingButton,
    ModalDelete,
    ModalEdit,
    DataTable,
    SwitchInput,
    TextInput,
    SelectInput,
    DateInput,
    VueSelectInput,
    MaskInput,
    TimeInput,
  },
  computed: {
    problemList: function() {
      if(this.$refs.modalEdit?.item?.type == 'cid10') {
        return this.care_plan_problems()['cid'];
      } else if(this.$refs.modalEdit?.item?.type == 'ciap2') {
        return this.care_plan_problems()['ciap'];
      }
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  data() {
    return {
      loadTable: true,
      columns: [
        {
          uniqid: 'care_plan_type',
          label: 'Tipo',
          field: 'type',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? row.type_label : ''
        },
        {
          uniqid: 'care_plan_problem',
          label: 'Problema',
          field: 'problem',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? row.problem_label : ''
        },
        {
          uniqid: 'care_plan_goal',
          label: 'Meta',
          field: 'goal',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? val.substr(0, 50) : ''
        },
        {
          uniqid: 'care_plan_professional',
          label: 'Profissional',
          field: 'professional_user.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.id ? row.professional.user.name : ''
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: this.user.role == 2 ? true : false,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/patients/care-plans/${item.id}`, `Deseja realmente excluir o plano de cuidado ${item.goal}?`);
    },
    openModalEdit(i) {
      this.$refs.modalEdit.openModalEdit({
        id: i.id,
        goal: i.goal,
        problem: i.problem,
        type: i.type,
        professional: i.professional ?? {},
        activities: i.activities ?? [],
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    deleteActivity(form, activity) {
      form.activities.splice(form.activities.indexOf(activity), 1);
    },
  },
}
</script>